import { Injectable } from '@angular/core';
import {
  InjectableRxStompConfig,
  RxStompService,
  rxStompServiceFactory,
} from '@stomp/ng2-stompjs';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as SockJS from 'sockjs-client';
import { AppInitService } from './app-init.service';
import { AuthenticationService } from './authentication.service';
import { Message } from '@stomp/stompjs';
import { RxStompState } from '@stomp/rx-stomp';
@Injectable({ providedIn: 'root' })
export class DSignStompWebsocketService {
  private websocketStatusSubject: BehaviorSubject<number>;
  private watchPathConstant = '/userUniqueId/topic';
  constructor(
    private rxStompConfig: InjectableRxStompConfig,
    private rxStompService: RxStompService,
    private authService: AuthenticationService,
    private appInitService: AppInitService
  ) {
    this.websocketStatusSubject = new BehaviorSubject(null);
    if (this.appInitService.appConfig?.websocket) {
      this.websocketStatusSubject.next(0);
      // this.authService.loggedInUserSubject.subscribe((loginDetails) => {
      //   if (loginDetails?.employeeVO?.uniqueId) {
      //     this.connect();
      //   } else {
      //     this.disconnect();
      //   }
      // });
    }
  }
  private fetchConfig(): InjectableRxStompConfig {
    const uniqueId = this.authService.loggedInUser?.employeeVO?.uniqueId;
    const url = 'https://127.0.0.1:10007';
    //const url = 'https://10.170.68.179:8027' + '/eventstore/connect';

    const myRxStompConfig: InjectableRxStompConfig = {
      // Which server?
      //brokerURL: stompUrl,  ///not provided because we are using sockJS instead of websocket

      // Headers
      // Typical keys: login, passcode, host
      connectHeaders: {
        userUniqueId: uniqueId,
      },
      // How often to heartbeat?
      // Interval in milliseconds, set to 0 to disable
      heartbeatIncoming: 600000, // Typical value 0 - disabled
      heartbeatOutgoing: 55000, // Typical value 20000 - every 20 seconds

      // Wait in milliseconds before attempting auto reconnect
      // Set to 0 to disable
      // Typical value 5000 (5 seconds)
      reconnectDelay: 5000,

      // Will log diagnostics on console
      // It can be quite verbose, not recommended in production
      // Skip this key to stop logging to console
      /* debug: (msg: string): void => {
        console.log(`WEBSOCKET ${new Date()}`, msg);
      }, */
    };
    myRxStompConfig.webSocketFactory = function () {
      return new SockJS(url);
    };
    return myRxStompConfig;
  }

  public connect() {
    this.rxStompConfig = this.fetchConfig();
    this.rxStompService = rxStompServiceFactory(this.rxStompConfig);
    this.rxStompService.activate();
    this.websocketStatusSubject.next(RxStompState.OPEN);
    let statusId = 0;
    this.rxStompService.connectionState$.asObservable().subscribe((status) => {
      if (status === RxStompState.CLOSED && statusId !== RxStompState.CLOSED) {
        this.websocketStatusSubject.next(RxStompState.CLOSED);
        statusId = RxStompState.CLOSED;
      } else if (
        statusId === RxStompState.CLOSED &&
        status === RxStompState.OPEN
      ) {
        this.websocketStatusSubject.next(RxStompState.OPEN);
      }
    });
  }

  public disconnect() {
    this.rxStompService.deactivate();
    this.websocketStatusSubject.next(RxStompState.CLOSED);
  }

  public receiveMessage(topicName: string) {
    if (topicName.charAt(0) !== '/') {
      topicName = '/' + topicName;
    }
    topicName = this.watchPathConstant + topicName;
    return this.rxStompService
      .watch(topicName)
      .pipe(map((res: Message) => res?.body));
  }

  get websocketStatus(): Observable<number> {
    return this.websocketStatusSubject.asObservable();
  }

  public sendMessage(topicName: string, message: string) {
    if (topicName.charAt(0) !== '/') {
      topicName = '/' + topicName;
    }
    topicName = this.watchPathConstant + topicName;
    var messageJson = {
      Date: `${new Date()}`,
      Message: message,
    };
    return this.rxStompService.publish({
      destination: topicName,
      body: JSON.stringify(messageJson),
    });
  }

  private ngOnDestroy() {
    this.rxStompService.deactivate();
  }
}
